import { getCurrentLearnerId } from '../../../../../global/LearnerContextProvider';
import { createCompletedItemsStoreFromState } from '../../../../features/tracking/models/CompletedItemsStore';
import { clearVideoProgressByGroup } from '../../../../features/tracking/services/videoProgressStorage';
import { StudentStoreThunkAction } from '../../../../types/redux';
import { maybeMarkCourseComplete, persistTrackingChange } from '../../../middleware/tracking/persistTrackingChange';
import { Guid } from '../../../model/guid';
import { getItemByIdAllowUndefinedSelector } from '../../items/itemsSelectors';
import { Quiz, TrackingIdentifier } from '@ael/core-api';

export enum trackingAction {
  Tracking_AddItem = 'Tracking_AddItem',
  Tracking_ResetProgress = 'Tracking_ResetProgress',
  Tracking_RemoveQuizItems = 'Tracking_RemoveQuizItems',
}

export const addStartOfItem =
  (itemId: Guid): StudentStoreThunkAction =>
  async (dispatch, getState, { trackingClient }) => {
    const completedItemsStore = createCompletedItemsStoreFromState(getState());
    completedItemsStore.addStartedItem(itemId);
    dispatch({ type: trackingAction.Tracking_AddItem, payload: completedItemsStore.toJS() });
    await persistTrackingChange(getState, trackingClient);
  };

export const addCompletedItem =
  (itemId: Guid): StudentStoreThunkAction =>
  async (dispatch, getState, { trackingClient }) => {
    const completedItemsStore = createCompletedItemsStoreFromState(getState());
    completedItemsStore.addFinishedItem(itemId);
    dispatch({ type: trackingAction.Tracking_AddItem, payload: completedItemsStore.toJS() });
    await persistTrackingChange(getState, trackingClient);
    await maybeMarkCourseComplete(dispatch, getState, trackingClient);
  };

export const resetCompletedItems: StudentStoreThunkAction = async (dispatch, getState, { trackingClient }) => {
  const completedItemsStore = createCompletedItemsStoreFromState(getState());
  completedItemsStore.reset();
  // Clear video progress for this user when resetting progress
  clearVideoProgressByGroup(getCurrentLearnerId());
  dispatch({
    type: trackingAction.Tracking_ResetProgress,
    payload: completedItemsStore.toJS(),
  });
  await persistTrackingChange(getState, trackingClient);
};

export const removeQuizCompletedItems =
  (quiz: Quiz): StudentStoreThunkAction =>
  async (dispatch, getState, { trackingClient }) => {
    const completedItemsStore = createCompletedItemsStoreFromState(getState());
    // cannot used typed selector due to both questions and hidden areas being in the quiz.
    const getItemById = getItemByIdAllowUndefinedSelector(getState());
    const quizItemTrackingIds: TrackingIdentifier[] = [];

    quiz.contentItems.forEach((itemId: string) => {
      completedItemsStore.removeFinishedItem(itemId);
      const item = getItemById(itemId);
      if (item) {
        quizItemTrackingIds.push(item.trackingIdentifier);
      }
    });

    dispatch({
      type: trackingAction.Tracking_RemoveQuizItems,
      payload: completedItemsStore.toJS(),
      quizItemTrackingIds,
    });
    await persistTrackingChange(getState, trackingClient);
  };
